import TimelineDot from '@mui/lab/TimelineDot';
export default TimelineDot;
export * from '@mui/lab/TimelineDot';
